module.exports = __webpack_public_path__ + "img/fifthfeatureicon.b5d51a15.webp";